let module = angular.module('checkout', []);

module.config(($stateProvider) => {
  'ngInject';

  $stateProvider.state('checkout', {
    url: '/:pd_did?pd_sid?start_step',
    template: ``,
    controller: ($state) => {
      // Remove undefined params
      Object.keys($state.params).forEach((key) => {
        if (!$state.params[key]) {
          delete $state.params[key];
        }
      });
      const urlParams = new URLSearchParams($state.params);
      window.location.replace(`${window.VUE_DASHBOARD_ROOT}/checkout?` + urlParams);
    },
  });
});

export default module;



// WEBPACK FOOTER //
// ./app/pages/checkout/_index.js